import { ReactElement, ReactNode, MouseEvent } from 'react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

interface NotificationPanelFilterSelectorProps {
  icon: ReactElement;
  title: string;
  children?: ReactNode | null;
  onClick: (e: MouseEvent) => void;
}

export function NotificationPanelFilterSelector(props: NotificationPanelFilterSelectorProps) {
  const { icon, title, children, onClick } = props;
  return (
    <div
      data-cy={`notif-filter-${title.toString().toLowerCase().replace(' ', '-')}`}
      onClick={onClick}
      className="h-8 bg-neutral-100 border border-neutral-200 rounded mb-1 flex transition-colors duration-200 text-[13px] text-neutral-800 leading-5 hover:bg-zinc-50 cursor-pointer"
    >
      <div className="flex items-center px-1.5">
        <Icon icon={icon} className="size-4 mr-2 text-neutral-500 shrink-0" />
        <span className="text-nowrap">{title}:</span>
      </div>
      <div className="grow flex items-center justify-end pr-1">{children ? children : null}</div>
      <div className="flex items-center pr-1.5">
        <Icon icon={IconsMap.ARROW_RIGHT} className="size-4 shrink-0 text-neutral-500" />
      </div>
    </div>
  );
}
